import { catalogueService } from '../services';
import type { CatalogueProfile } from '../types/catalogue.types';
import { type CatalogueSectionService, useCatalogueSection } from './useCatalogueSection';

const CATALOGUE_PROFILES_PAGE_SIZE = 6;

const catalogueProfileService: CatalogueSectionService<'vendorId', string, CatalogueProfile> = {
  itemIdName: 'vendorId',
  pageSize: CATALOGUE_PROFILES_PAGE_SIZE,
  itemsLabel: 'profile',
  fetchPage: async (cursor) => await catalogueService.getAllProfiles(CATALOGUE_PROFILES_PAGE_SIZE, cursor),
  approveItem: async (profileId, versionId) => await catalogueService.approveProfile(profileId, versionId),
  rejectItem: async (profileId, versionId) => await catalogueService.suspendProfile(profileId, versionId),
  bulkApproveItems: async (infos) => await catalogueService.bulkApproveProfiles(infos),
}

export const useCatalogueProfiles = () => {
  const { items, approveItem, rejectItem, approveAllItems, loading, pagination } = useCatalogueSection(
    catalogueProfileService
  )

  return {
    profiles: items,
    approveProfile: approveItem,
    suspendProfile: rejectItem,
    approveAllProfiles: approveAllItems,
    loading,
    pagination
  }
};
